import { render, staticRenderFns } from "./InquiryStatusLabel.vue?vue&type=template&id=a2cfce44&"
import script from "./InquiryStatusLabel.vue?vue&type=script&lang=js&"
export * from "./InquiryStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./InquiryStatusLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports